module.exports = __webpack_public_path__ + "static/media/background.1c5f3ca5.png";